import { get, post, deleteUrl } from './axios.js'

export const projectInfo = obj => get('/project/info', obj)

export const articlePage = obj => get('/article/page', obj)

export const articleInfo = obj => get('/article/info', obj)

export const doctorInfo = obj => get('/doctor/info', obj)

export const divisionInfo = obj => get('/division/info', obj)

export const drugInfo = obj => get('/drug/page', obj)

export const drugInfoDetail = obj => get('/drug/info', obj)
